import React from "react";
import { Modal, Box, Typography, Fade} from "@mui/material";
import CustomButton from "../../../shared/CustomButton";
import { useDispatch } from "react-redux";
import  {reGenerateNotification} from '../../state/alertActions'
const Modalstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  height: 200,
  bgcolor: "background.paper",
  borderRadius: '6px',
  padding:"24px 24px 0 24px",
  display:"flex",
flexDirection:"column"
};
const ReGenerateNotification = ({
  open,
  onClose,
  rows,
  error,
  success,
  sentSuccess
}) => {


const dispatch = useDispatch()

const saveChanges = (rows) => {
let data ={"messagesToBeRegenerated":rows.map((element) => ({"logId":element?.id}))}
console.log(data)
dispatch(reGenerateNotification(data,error,success)).then(() => {
  onClose() 
})
}


const returnWarning = () => {
    const checkGenerateFlag = rows.map((row)=>row.sendStatus).includes(sentSuccess)
    switch (checkGenerateFlag) {
        case true:
            return("Some of the selected Notifications were already generated. Are you sure you want to re-generate it again?")
       case false:
        return("regenerating the Notifications. Are you sure you want to re-generate it again?")
        default:
            break;
    }
}

  return (
    <Modal
      open={open}
      onClose={onClose}
      disableEnforceFocus
      disableAutoFocus
 
    >
          <Fade in>
          <Box sx={Modalstyle}>
        <Box>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: 500,
              lineHeight: "24px",
              color:"#050D2E",
            }}
          >
Re-generate Alerts!
          </Typography>
        </Box>
          <Typography
            id="modal-un-saved-changes"
            sx={{
              color: "#50566E",
              fontSize: "16px",
              fontWeight:400,
              margin:"10px 0"
            }}
          >
         {returnWarning()}
          </Typography>
       <Box
     sx={{
      alignSelf:"end",
      flexGrow:0.5,
      alignItems:"end",
      display:"flex"
     }}
       >
       <Box
         sx={{
          display:"flex",
          gap:1
         }}
          
        >
          <CustomButton
            text="Cancel"
            type="secondary"
            processing={false}
            action={onClose}
          />
          <CustomButton
            text="Yes, Re-generate"
            type="update"
            action={() => saveChanges(rows)}
          />
        </Box>
       </Box>
      </Box>
          </Fade>
     
    </Modal>
  );
};

export default ReGenerateNotification;
